import { render, staticRenderFns } from "./CreateCourseCategory.vue?vue&type=template&id=0c1fc66e&scoped=true"
import script from "./CreateCourseCategory.vue?vue&type=script&lang=js"
export * from "./CreateCourseCategory.vue?vue&type=script&lang=js"
import style0 from "./CreateCourseCategory.vue?vue&type=style&index=0&id=0c1fc66e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1fc66e",
  null
  
)

export default component.exports